import { FORM_URL_KEY } from '@global/constants/form';

export const pathnameToText = (str = '') => {
  switch (str.split('/')[1]) {
    case 'login':
      return 'Sign up / Login';
    case 'notifications':
      return 'Notifications';
    case 'profile':
      return 'Profile';
    // case `${links.EKYC}`:
    //   return 'Verify Documents';
    case 'docs':
      return 'Verify Documents';
    case 'submitted':
      return 'Verify Documents';
    case 'digilocker':
      return 'Verify Documents';
    case 'displayInfo':
      return `Verify Document`;
    case 'user-input':
      return `Input User Details`;
    case 'transaction-history':
      return `Payment Details`;
    case 'payment':
      return `Payment Details`;
    case 'insufficiency':
      return `Document Details`;
    case 'info':
      return `Info`;
    case 'profile-form':
      return `Profile Form`;
    case 'under-process':
      return 'Under Process';
    case 'terms':
      return 'Terms and Conditions';
    case 'privacy-policy':
      return 'Privacy Policy';
    case 'choose-payment-provider':
      return 'Choose Payment Provider';
    case 'choose-payment-region':
      return 'Choose Payment Region';
    case 'form-payments':
      return 'Payment Details';
    case 'select-mode':
      return 'Select Mode';
    case 'contact-details':
      return 'Contact Details';
    case 'profile-mode':
      return 'Profile Mode';
    case 'basic-details':
      return 'Basic Details';
    case 'verification':
      return 'Verification';
    // case '': return `Hi ${fetchFromStore('currentUserData')?.name || ''}`;
    default:
      return ' ';
  }
};

export const pathnameToBackLink = (str = '', specificLink = '') => {
  switch (str.split('/')[1]) {
    case 'submitted':
      return null;
    case 'login':
      return null;
    case 'choose-payment-provider':
      return specificLink;
    // case 'docs': return specificLink;
    case 'form-payments':
      return specificLink;
    case FORM_URL_KEY:
      return '/';
    // case 'profile': return null;
    // case '': return `Hi ${fetchFromStore('currentUserData')?.name || ''}`;
    default:
      return -1;
  }
};
